<template>
  <v-card tile :color="config.background" :dark="config.dark">
    <v-card-text class="text-center subtitle-1">
      <v-list three-line :color="config.background" :dark="config.dark" dense>
      <v-list-item>
        <v-list-item-avatar tile size="80" class="pa-0 ma-0">
          <v-img src="../../assets/images/empleados.png"></v-img>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title class="text-h5 pa-2">
            {{ information.amount }}
          </v-list-item-title>
          <v-list-item-subtitle>{{ information.name }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      </v-list>

    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'Indicator-Card',
  props: ['config'],
  data: () => ({
    configuration: {
      background: 'light-green darken-3',
      background_dark: 'light-green darken-4',
      dark: false
    },
    information: {
      name: '',
      amount: 30
    }
  }),
  created () {
    if (this.config) {
      this.configuration = this.config
      this.information = this.config.data
    }
  }
}
</script>

<style>

</style>
